(function () {
  'use strict';

  function escapeAttr(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function closest(el, sel) {
    return el && el.closest ? el.closest(sel) : null;
  }

  function initMoments(root) {
    if (!root || root.dataset.smrReady === '1') return;
    root.dataset.smrReady = '1';

    var platformBtns = root.querySelectorAll('[data-smr-platform]');
    var items = root.querySelectorAll('[data-platform]');
    var empty = root.querySelector('[data-smr-empty]');
    var filtersBtn = root.querySelector('[data-smr-filters-toggle]');
    var advanced = root.querySelector('[data-smr-advanced]');
    var active = 'tiktok';

    function applyFilter(platform) {
      active = platform || 'tiktok';
      var visible = 0;
      items.forEach(function (item) {
        var p = (item.getAttribute('data-platform') || '').toLowerCase();
        var show = active === 'all' || p === active || p === 'all';
        item.hidden = !show;
        if (show) visible += 1;
      });
      platformBtns.forEach(function (btn) {
        var isActive = btn.getAttribute('data-smr-platform') === active;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      if (empty) empty.classList.toggle('is-visible', visible === 0);
    }

    platformBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyFilter(btn.getAttribute('data-smr-platform'));
      });
    });

    if (filtersBtn && advanced) {
      filtersBtn.addEventListener('click', function () {
        var open = advanced.hasAttribute('hidden');
        if (open) advanced.removeAttribute('hidden');
        else advanced.setAttribute('hidden', '');
        filtersBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    applyFilter(active);
  }

  function initReviews(root) {
    if (!root || root.dataset.smrReviewsReady === '1') return;
    root.dataset.smrReviewsReady = '1';

    var product = 'all';
    var platform = 'all';
    var rowsShown = 1;
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-smr-exp]'));
    var grid = root.querySelector('[data-smr-reviews-grid]');
    var empty = root.querySelector('[data-smr-reviews-empty]');
    var moreBtn = root.querySelector('[data-smr-reviews-more]');
    var moreWrap = root.querySelector('[data-smr-reviews-more-wrap]');
    var allLoaded = root.querySelector('[data-smr-reviews-all-loaded]');
    var countEl = root.querySelector('[data-smr-reviews-count]');
    var productWrap = root.querySelector('[data-smr-product-filters]');
    var platformWrap = root.querySelector('[data-smr-platform-filters]');
    var clearBtn = root.querySelector('[data-smr-clear-filters]');

    function colsPerRow() {
      var w = window.innerWidth || 0;
      if (w <= 749) return 1;
      if (w <= 989) return 4;
      return 4;
    }

    function pageSize() {
      var w = window.innerWidth || 0;
      if (w <= 749) {
        var base = parseInt(root.getAttribute('data-smr-page-size') || '8', 10);
        if (!base || base < 1) base = 8;
        return base;
      }
      return colsPerRow();
    }

    function setCardHidden(card, hide) {
      if (hide) {
        card.hidden = true;
        card.setAttribute('aria-hidden', 'true');
        card.classList.add('is-smr-hidden');
        card.classList.remove('is-paged-in');
      } else {
        card.hidden = false;
        card.removeAttribute('aria-hidden');
        card.classList.remove('is-smr-hidden');
        card.classList.add('is-paged-in');
      }
    }

    function matchedCards() {
      return cards.filter(function (card) {
        var p = (card.getAttribute('data-platform') || '').toLowerCase();
        var c = (card.getAttribute('data-product') || '').toLowerCase();
        var kind = (card.getAttribute('data-kind') || 'video').toLowerCase();
        var okPlatform = platform === 'live' ? kind === 'live' : kind !== 'live' && (platform === 'all' || p === platform);
        var okProduct = product === 'all' || c === product;
        return okPlatform && okProduct;
      });
    }

    function syncPlatformAvailability() {
      // Keep all platform buttons clickable so empty platforms show the empty state
      // instead of looking like a broken filter.
    }

    function render() {
      var matched = matchedCards();
      var limit = rowsShown * pageSize();

      cards.forEach(function (card) {
        setCardHidden(card, true);
      });

      matched.forEach(function (card, index) {
        setCardHidden(card, index >= limit);
      });

      if (productWrap) {
        productWrap.querySelectorAll('[data-smr-product]').forEach(function (btn) {
          var on = btn.getAttribute('data-smr-product') === product;
          btn.classList.toggle('is-active', on);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }

      if (platformWrap) {
        platformWrap.querySelectorAll('[data-smr-platform-filter]').forEach(function (btn) {
          var on = btn.getAttribute('data-smr-platform-filter') === platform;
          btn.classList.toggle('is-active', on);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }

      if (countEl) {
        countEl.textContent = matched.length ? String(matched.length) : '0';
      }

      if (empty) {
        if (matched.length === 0) empty.removeAttribute('hidden');
        else empty.setAttribute('hidden', '');
      }

      if (moreWrap) {
        if (matched.length === 0) {
          moreWrap.hidden = true;
        } else {
          moreWrap.hidden = false;
          var hasMore = limit < matched.length;
          if (moreBtn) {
            moreBtn.hidden = !hasMore;
            moreBtn.disabled = !hasMore;
          }
          if (allLoaded) {
            if (hasMore) allLoaded.setAttribute('hidden', '');
            else allLoaded.removeAttribute('hidden');
          }
        }
      }

      if (grid) {
        grid.dataset.smrMatched = String(matched.length);
        grid.dataset.smrVisible = String(Math.min(limit, matched.length));
        grid.dataset.smrCols = String(pageSize());
      }
    }

    function resetRowsAndRender() {
      rowsShown = 1;
      render();
    }

    if (productWrap) {
      productWrap.addEventListener('click', function (e) {
        var btn = e.target && e.target.closest ? e.target.closest('[data-smr-product]') : null;
        if (!btn || !productWrap.contains(btn)) return;
        e.preventDefault();
        product = btn.getAttribute('data-smr-product') || 'all';
        resetRowsAndRender();
      });
    }

    if (platformWrap) {
      platformWrap.addEventListener('click', function (e) {
        var btn = e.target && e.target.closest ? e.target.closest('[data-smr-platform-filter]') : null;
        if (!btn || !platformWrap.contains(btn) || btn.disabled) return;
        e.preventDefault();
        e.stopPropagation();
        platform = btn.getAttribute('data-smr-platform-filter') || 'all';
        resetRowsAndRender();
      });
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', function (e) {
        e.preventDefault();
        rowsShown += 1;
        render();
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function (e) {
        e.preventDefault();
        product = 'all';
        platform = 'all';
        resetRowsAndRender();
      });
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        rowsShown = 1;
        render();
      }, 150);
    });

    syncPlatformAvailability();
    render();
  }

  function initNews(root) {
    if (!root || root.dataset.smrNewsReady === '1') return;
    root.dataset.smrNewsReady = '1';

    var tabs = root.querySelectorAll('[data-smr-news-tab]');
    var cards = root.querySelectorAll('[data-smr-news-card]');
    var emptyEl = root.querySelector('[data-smr-news-empty]');
    if (!tabs.length) return;

    function apply(tag) {
      var visible = 0;
      cards.forEach(function (card) {
        var tags = (card.getAttribute('data-tags') || '').toLowerCase();
        var show =
          tag === 'all' ||
          (' ' + tags + ' ').indexOf(' ' + tag + ' ') !== -1 ||
          tags.split(/\s+/).indexOf(tag) !== -1;
        card.hidden = !show;
        if (show) visible += 1;
      });
      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-smr-news-tab') === tag;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (emptyEl) {
        // Keep empty state visible when there are no articles at all,
        // or when the active tab filters everything out.
        emptyEl.hidden = cards.length > 0 && visible > 0;
      }
      return visible;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        apply(tab.getAttribute('data-smr-news-tab') || 'all');
      });
    });

    apply('all');
  }

  function getModal() {
    var modal = document.querySelector('[data-smr-modal]');
    if (modal) return modal;

    modal = document.createElement('div');
    modal.className = 'smr-modal';
    modal.setAttribute('data-smr-modal', '');
    modal.hidden = true;
    modal.innerHTML =
      '<div class="smr-modal__backdrop" data-smr-modal-close></div>' +
      '<div class="smr-modal__dialog" role="dialog" aria-modal="true" aria-label="' +
      escapeAttr((window.accessibilityStrings && window.accessibilityStrings.video) || 'Video') +
      '">' +
      '<button type="button" class="smr-modal__close" data-smr-modal-close aria-label="' +
      escapeAttr((window.accessibilityStrings && window.accessibilityStrings.close) || 'Close') +
      '">×</button>' +
      '<div data-smr-modal-body></div>' +
      '</div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (e) {
      if (e.target && e.target.hasAttribute('data-smr-modal-close')) closeModal(modal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal(modal);
    });
    return modal;
  }

  function closeModal(modal) {
    var body = modal.querySelector('[data-smr-modal-body]');
    if (body) body.innerHTML = '';
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  function openModal(url) {
    if (!url) return;
    var modal = getModal();
    var body = modal.querySelector('[data-smr-modal-body]');
    var isMp4 = /\.mp4($|\?)/i.test(url) || /shopify\.com|cdn\.shopify/i.test(url);
    body.innerHTML = '';
    if (isMp4) {
      var video = document.createElement('video');
      video.className = 'smr-modal__video';
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      video.src = url;
      body.appendChild(video);
    } else {
      var iframe = document.createElement('iframe');
      iframe.className = 'smr-modal__frame';
      iframe.src = url;
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      body.appendChild(iframe);
    }
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function initVideoClicks(root) {
    root.addEventListener('click', function (e) {
      var trigger = closest(e.target, '[data-smr-video-open]');
      if (!trigger) return;
      e.preventDefault();

      var live = trigger.getAttribute('data-live-url');
      var isLive = trigger.getAttribute('data-is-live') === 'true';
      if (isLive && live) {
        window.open(live, '_blank', 'noopener');
        return;
      }

      var external = trigger.getAttribute('data-external-url');
      var videoUrl = trigger.getAttribute('data-video-url');

      if (videoUrl && !/^https?:\/\/(www\.)?(tiktok|instagram|facebook|line)\./i.test(videoUrl) && !/vt\.tiktok\.com/i.test(videoUrl)) {
        openModal(videoUrl);
        return;
      }

      if (external) {
        window.open(external, '_blank', 'noopener');
        return;
      }

      if (videoUrl) {
        if (/\.mp4($|\?)/i.test(videoUrl)) openModal(videoUrl);
        else window.open(videoUrl, '_blank', 'noopener');
      }
    });
  }

  function initCommunityFlip(root) {
    if (!root || root.dataset.smrFlipReady === '1') return;
    root.dataset.smrFlipReady = '1';

    var book = root.querySelector('[data-smr-flip-book]');
    var pages = book ? Array.prototype.slice.call(book.querySelectorAll('[data-smr-flip-page]')) : [];
    if (!book || pages.length < 2) return;

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-smr-flip-dot]'));
    var status = root.querySelector('[data-smr-flip-status]');
    var index = 0;
    var dragging = null;
    var startX = 0;
    var startY = 0;
    var lastDx = 0;
    var pointerId = null;
    var didDrag = false;

    function pageWidth() {
      return book.getBoundingClientRect().width || 1;
    }

    function syncZ(frontIndex) {
      var n = pages.length;
      pages.forEach(function (page, i) {
        if (i === frontIndex) page.style.zIndex = String(n * 2 + 2);
        else if (page.classList.contains('is-flipped')) page.style.zIndex = String(i + 1);
        else page.style.zIndex = String(n + (n - i));
      });
    }

    function syncUi() {
      pages.forEach(function (page, i) {
        page.classList.toggle('is-current', i === index);
        page.classList.toggle('is-flipped', i < index);
        page.classList.remove('is-turning', 'is-dragging');
        page.style.transform = '';
        page.style.transition = '';
      });
      syncZ(index);
      dots.forEach(function (dot, i) {
        var on = i === index;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (status) status.textContent = (index + 1) + ' / ' + pages.length;
    }

    function goTo(next) {
      next = Math.max(0, Math.min(pages.length - 1, next));
      if (next === index) {
        syncUi();
        return;
      }
      var from = index;
      index = next;
      if (!reduced) {
        if (next > from) pages[from].classList.add('is-turning');
        else if (from > 0) pages[from - 1].classList.add('is-turning');
      }
      pages.forEach(function (page, i) {
        page.classList.toggle('is-flipped', i < index);
        page.classList.toggle('is-current', i === index);
        page.style.transform = '';
      });
      syncZ(index);
      window.setTimeout(syncUi, reduced ? 0 : 720);
    }

    function onPointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      lastDx = 0;
      dragging = null;
      didDrag = false;
      try { book.setPointerCapture(pointerId); } catch (err) {}
    }

    function onPointerMove(event) {
      if (pointerId == null || event.pointerId !== pointerId) return;
      var dx = event.clientX - startX;
      var dy = event.clientY - startY;
      lastDx = dx;
      if (!dragging) {
        if (Math.abs(dx) < 14) return;
        if (Math.abs(dx) < Math.abs(dy) * 1.15) {
          pointerId = null;
          return;
        }
        dragging = dx < 0 ? 'next' : 'prev';
        didDrag = true;
      }
      event.preventDefault();
      var w = pageWidth();
      if (dragging === 'next' && index < pages.length - 1) {
        var page = pages[index];
        var p = Math.max(0, Math.min(1, -dx / w));
        page.classList.add('is-dragging', 'is-turning');
        page.style.transition = 'none';
        page.style.transform = 'rotateY(' + (-180 * p) + 'deg)';
        syncZ(index);
      } else if (dragging === 'prev' && index > 0) {
        var back = pages[index - 1];
        var q = Math.max(0, Math.min(1, dx / w));
        back.classList.add('is-dragging', 'is-turning');
        back.style.transition = 'none';
        back.style.transform = 'rotateY(' + (-180 + 180 * q) + 'deg)';
        syncZ(index - 1);
      }
    }

    function onPointerUp(event) {
      if (pointerId == null || event.pointerId !== pointerId) return;
      pointerId = null;
      try { book.releasePointerCapture(event.pointerId); } catch (err) {}
      var w = pageWidth();
      var passed = Math.abs(lastDx) > w * 0.22;
      if (dragging === 'next' && passed && index < pages.length - 1) goTo(index + 1);
      else if (dragging === 'prev' && passed && index > 0) goTo(index - 1);
      else syncUi();
      dragging = null;
      lastDx = 0;
    }

    book.addEventListener('pointerdown', onPointerDown);
    book.addEventListener('pointermove', onPointerMove, { passive: false });
    book.addEventListener('pointerup', onPointerUp);
    book.addEventListener('pointercancel', onPointerUp);
    book.addEventListener('click', function (event) {
      if (didDrag) {
        event.preventDefault();
        didDrag = false;
        return;
      }
      var rect = book.getBoundingClientRect();
      if (event.clientX < rect.left + rect.width * 0.34) goTo(index - 1);
      else goTo(index + 1);
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(Number(dot.getAttribute('data-smr-flip-dot')) || 0);
      });
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') goTo(index + 1);
      if (event.key === 'ArrowLeft') goTo(index - 1);
    });

    syncUi();
    if (!reduced && pages[0]) {
      pages[0].classList.add('is-hint');
      window.setTimeout(function () {
        pages[0].classList.remove('is-hint');
      }, 2200);
    }
  }

  function boot() {
    document.querySelectorAll('[data-smr-moments]').forEach(function (root) {
      initMoments(root);
      initVideoClicks(root);
    });
    document.querySelectorAll('[data-smr-reviews]').forEach(initReviews);
    document.querySelectorAll('[data-smr-news]').forEach(initNews);
    document.querySelectorAll('[data-smr-flip]').forEach(initCommunityFlip);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
